// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as CSS$Showside from "../utils/CSS.bs.js";
import * as DataAttribute$Showside from "../utils/DataAttribute.bs.js";
import * as ReactDOMUtils$Showside from "../utils/ReactDOMUtils.bs.js";
import ReactVisibilitySensor from "react-visibility-sensor";
function PDPCTAWrapper(Props) {
  var style = Props.style;
  var className = Props.className;
  var initial = Props.initial;
  var onChangeVisibility = Props.onChangeVisibility;
  var children = Props.children;
  var match = React.useState(function () {
    return initial === /* Visible */3;
  });
  var setVisible = match[1];
  var visible = match[0];
  var ref = React.useRef(null);
  var getY = function (param) {
    return Belt_Option.map(Caml_option.nullable_to_opt(ref.current), function (el) {
      return el.getBoundingClientRect().y;
    });
  };
  var getVisibility = function (visible) {
    var currentY = getY(undefined);
    if (visible) {
      return /* Visible */3;
    } else if (currentY !== undefined) {
      if (currentY > 0) {
        return /* HiddenTop */0;
      } else if (currentY < 0) {
        return /* HiddenBottom */1;
      } else {
        return /* Hidden */2;
      }
    } else {
      return /* Hidden */2;
    }
  };
  React.useEffect(function () {
    Belt_Option.forEach(onChangeVisibility, function (cb) {
      Curry._1(cb, getVisibility(visible));
    });
  }, []);
  var tmp = {
    ref: ReactDOMUtils$Showside.Ref.domRef(ref)
  };
  if (className !== undefined) {
    tmp.className = Caml_option.valFromOption(className);
  }
  if (style !== undefined) {
    tmp.style = Caml_option.valFromOption(style);
  }
  return React.createElement(DataAttribute$Showside.make, {
    dataTestId: "pdp-cta-wrapper",
    children: React.createElement("div", tmp, children, React.createElement(ReactVisibilitySensor, {
      partialVisibility: false,
      onChange: function (visible) {
        var fn = function (param) {
          return visible;
        };
        Curry._1(setVisible, function (previous) {
          var next = Curry._1(fn, previous);
          Belt_Option.forEach(onChangeVisibility, function (cb) {
            Curry._1(cb, getVisibility(next));
          });
          return next;
        });
      },
      children: React.createElement("div", {
        className: CSS$Showside.prefix("absolute top-0 left-0 w-full h-full pointer-events-none")
      })
    }))
  });
}
PDPCTAWrapper.displayName = "PDPCTAWrapper";
var make = PDPCTAWrapper;
export { make };
/* react Not a pure module */